<template>
  <bb-modal
    visible
    @close="$emit('close')"
    v-bind="modalProps">
    <template #heading>
      <div class="deposit_withdraw__title">
        {{ translations.headerText }}
      </div>
    </template>
    <div>
      <div class="illustration">
        <bb-icon class="icon" name="illustration-exclamation-mark" size="fluid" fill="mint-70" />
      </div>
      <div class="m-t-20 m-b-20 text-center">
        <p class="color-gray f-small">
          {{ translations.bodyText }}
        </p>
      </div>
    </div>
    <div slot="footer">
      <bb-button
        size="md"
        display="block"
        color="mint"
        :label="translations.closeButton"
        @click="$emit('close')"
      />
    </div>
  </bb-modal>
</template>

<script>
export default {
  props: {
    modalProps: {
      required: true
    }
  },
  computed: {
    translations () {
      return {
        closeButton: this.$pgettext('deposit_withdrawal_restricted', 'Close'),
        headerText: this.$pgettext('deposit_withdrawal_restricted', 'Withdrawal of funds failed'),
        bodyText: this.$pgettext('deposit_withdrawal_restricted', 'Due to account seizure, withdrawal of funds is restricted. Please contact our Customer Service on +372 713 1333 for more information.')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.illustration {
  width: 70%;
  margin: auto;
}
</style>
